
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import rules from "@/store/rules";

@Component
export default class PressJoinSettings extends Vue {
	@Prop()
	private toolId!: string;
	@Prop()
	private description!: string;
	private loading: boolean = false;
	private pressJoinMaterialSettingDtos: any = [];
	private requiredRule = rules.requiredRule;
	private requiredStringMax50Rule = rules.requiredStringMax50Rule;
	private requiredStringMax10Rule = rules.requiredStringMax10Rule;
	private requiredMax1DecimalNumberRule: any = [
		(v: number) => !!v.toString() || "Angabe erforderlich",
		(v: number) => !isNaN(v) || "Muss eine Zahl sein.",
	];

	private mounted() {
		this.loadSettings();
	}

	private async loadSettings() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Material/GetPressJoinMaterialSettings?toolId=${this.toolId}`
			);
			this.pressJoinMaterialSettingDtos = response.data;
			console.log(this.pressJoinMaterialSettingDtos);
		} catch {
			console.log("Loading settings failed.");
		} finally {
			this.loading = false;
		}
	}

	private setPressJoin(material: any) {
		if (material.toolId == null) {
			material.toolId = this.toolId;
		} else {
			material.toolId = null;
		}
	}

	private async savePressJoinToMaterialMaps() {
		try {
			this.loading = true;
			await httpClient().post(
				`Material/SavePressJoinToMaterialMaps?toolId=${this.toolId}`,
				this.pressJoinMaterialSettingDtos
			);
		} catch {
			console.log("Loading settings failed.");
		} finally {
			this.loading = false;
		}
	}
}
